const DEFAULT_API_GATEWAY_URL =
  "https://52y1lajjs2.execute-api.us-east-1.amazonaws.com/dev";

const runtimeConfig = window.appConfig || {};

export const cologuardApiConfig = Object.freeze({
  campaignBaseUrl:
    runtimeConfig.cologuardCampaignApiBaseUrl ||
    runtimeConfig.cologuardApiGatewayBaseUrl ||
    DEFAULT_API_GATEWAY_URL,
  historyBaseUrl:
    runtimeConfig.cologuardHistoryApiBaseUrl ||
    runtimeConfig.cologuardApiGatewayBaseUrl ||
    DEFAULT_API_GATEWAY_URL,
  metricsBaseUrl:
    runtimeConfig.cologuardMetricsApiBaseUrl ||
    runtimeConfig.cologuardApiGatewayBaseUrl ||
    DEFAULT_API_GATEWAY_URL,
  userBaseUrl:
    runtimeConfig.cologuardUserApiBaseUrl ||
    runtimeConfig.cologuardApiGatewayBaseUrl ||
    DEFAULT_API_GATEWAY_URL,
});

export function joinApiUrl(baseUrl, path) {
  return `${String(baseUrl).replace(/\/+$/, "")}/${String(path).replace(/^\/+/, "")}`;
}
